export enum DELIVERY_BAR_EXTERNAL_SERVICES {
  fetchShippingMethods = 'fetchShippingMethods',
  updateCustomerData = 'updateCustomerData',
  clearLocalStorage = 'clearLocalStorage',
  validateFormData = 'validateFormData',
  checkAddressEligibility = 'checkAddressEligibility',
  rehydrateContext = 'rehydrateContext',
}
